/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { ClientsListComponent } from '@app/clients/clients/clients-list/clients-list.component';
import { ClientsViewComponent } from '@app/clients/clients/clients-view/clients-view.component';
import { MenuService } from '@app/core/menu/menu.service';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'clients', component: ClientsListComponent, data: { title: extract('Clients') } },
    { path: 'clients/view', component: ClientsViewComponent, data: { title: extract('Clients view') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientsRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({
        key: 'clients',
        title: 'Clients',
        icon: 'fal fa-user-friends',
      })
      .addItem({
        key: 'clients.clients',
        title: 'Clients',
        requiredPermission: 'clients.menu',
        path: '/clients',
      });
  }
}
